export default __webpack_public_path__ + "static/media/stats.e2cb2ca2.png";